<template>
    <div class="container">
        <!-- Intro -->
        <img
            :src="`${publicPath}static/images/vivia-profile.jpg`"
            class="profile"
        />
        <h1 class="nome">
            Vívia Linhares
            <span class="d-none d-md-inline">Mesquita</span>
        </h1>
        <h4 class="especialidade">Neurologista</h4>
        <h4 class="crm">(CRM/CE: 13293 RQE: 7869)</h4>
        <hr />

        <!-- Especialidades -->
        <a class="anchor" id="especialidades"></a>
        <div class="row">
            <div class="col-lg-8">
                <h2>Especialidades</h2>
                <ul>
                    <li>
                        <strong>Doenças Neurodegenerativas</strong>
                    </li>
                    <li>Toxina Botulínica Terapêutica</li>
                    <li>Distúrbios do Movimento</li>
                    <li>Cefaleia</li>
                    <li>Neurologia Geral</li>
                </ul>
            </div>
            <div class="col-lg-4" style="text-align: center">
                <img
                    class="img-fluid rounded secicon"
                    :src="`${publicPath}static/images/brain2.png`"
                    alt
                />
            </div>
        </div>
        <!-- /.row -->
        <hr />

        <!-- Formacao -->
        <a class="anchor" id="formacao"></a>
        <div class="row">
            <div class="col-lg-8">
                <h2>Formação</h2>
                <ul>
                    <li>
                        <strong>2017 - 2018</strong> Especialização em Doenças
                        Neurodegenerativas - Secretaria de Saúde do Estado do
                        Ceará, SESA
                    </li>
                    <li>
                        <strong>2013 - 2016</strong> Residência médica em
                        Neurologia - Escola de Saúde Pública do Ceará, ESP/CE
                    </li>
                    <li>
                        <strong>2006 - 2011</strong> Graduação em Medicina -
                        Universidade Federal do Ceará
                    </li>
                </ul>
            </div>
            <div class="col-lg-4" style="text-align: center">
                <img
                    class="img-fluid rounded secicon"
                    :src="`${publicPath}static/images/academic2.png`"
                    alt
                />
            </div>
        </div>
        <hr />
        <!-- /Formacao -->

        <h1 class="mt-4 mb-3"><a class="anchor" id="contato"></a>Contato</h1>

        <div class="row">
            <div class="col-lg-8 mb-8">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.3162497472003!2d-38.512571024121414!3d-3.74108509623282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c748f3cafa8d79%3A0xabaa1fe605723bcb!2sRua%20Padre%20Valdevino%2C%201655%20-%20Aldeota%2C%20Fortaleza%20-%20CE%2C%2060135-041!5e0!3m2!1spt-BR!2sbr!4v1696126554175!5m2!1spt-BR!2sbr"
                    width="100%"
                    height="300"
                    frameborder="0"
                    style="border:0"
                    allowfullscreen
                ></iframe>
            </div>
            <div class="col-lg-4 mb-4">
                <div class="row">
                    <div class="col">
                        <h3>Endereço</h3>
                        <div class="row">
                            <div class="col">
                                <img
                                    :src="
                                        `${publicPath}static/images/qorpo-sm.png`
                                    "
                                    class="qorpo-sm"
                                />
                                <p>
                                    Rua Padre Valdevino, 1655 (esquina com Rua
                                    José Lourenço) - Aldeota, Fortaleza - CE,
                                    60135-041
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <h3>Telefones</h3>
                                <p>
                                    Central de Atendimento/Marcação de
                                    Consultas:
                                </p>
                                <ul>
                                    <li>
                                        WhatsApp
                                        <a
                                            href="whatsapp://send?phone=5585981495459&text="
                                            >(85) 98149.5459</a
                                        >
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            publicPath: process.env.BASE_URL,
        }
    },
}
</script>

<style>
.crm {
    font-size: 0.8em;
    /* line-height: 0.5; */
}
.nome {
    margin-top: 1.5em !important;
    margin-bottom: 0px !important;
}
.especialidade {
    margin-bottom: 0px !important;
}

.profile {
    border-radius: 50%;
    float: left;
    max-height: 100px;
    clear: both;
    margin-right: 1em;
}

.qorpo-sm {
    float: left;
    max-height: 1.5em;
    clear: both;
    margin-right: 0.5em;
}

.secicon {
    max-width: 75% !important;
    max-height: 180px;
}
</style>
